
import Vue from 'vue';
export default Vue.extend({
  name: 'TransitionExpand',

  props: {
    width: String,
  },

  methods: {
    enter(element: HTMLElement) {
      const width = this.width || getComputedStyle(element).width;
      const { visibility, height, position } = element.style;

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const nheight = getComputedStyle(element).height;
      element.style.width = width;
      element.style.position = position;
      element.style.visibility = visibility;
      element.style.height = height;

      // Trigger the animation.
      // We use `setTimeout` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      // setTimeout(() => {
      //   element.style.height = nheight;
      // });

      requestAnimationFrame(() => {
        element.style.height = nheight;
      });
    },
    afterEnter(element: HTMLElement) {
      element.style.height = 'auto';
    },
    leave(element: HTMLElement) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      // setTimeout(() => {
      //   element.style.height = '0';
      // });

      requestAnimationFrame(() => {
        element.style.height = '0';
      });
    },
  },
});
